<div class="scrollTop" [class.show]="show" (click)="scrollToTop()">
    <img src="../../../../assets/nav/go-to-top.svg" width="32" alt="Go to top">
</div>